const eventMapCreateModel = {
    id: null,
    eventId: "",  
    eventName:"",
    title: "", 
    mapFile:"",

};

export default eventMapCreateModel;